export default __webpack_public_path__ + "static/media/triangulo amarelo.92d6ef6a.svg";